import { render } from "./MenuBarRight.vue?vue&type=template&id=12374230&scoped=true"
import script from "./MenuBarRight.vue?vue&type=script&lang=js"
export * from "./MenuBarRight.vue?vue&type=script&lang=js"

import "./MenuBarRight.vue?vue&type=style&index=0&id=12374230&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12374230"]])

export default __exports__